import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Roles extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'rolessolicitud_add',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'rolessolicitud_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'rolessolicitud_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'rolessolicitud_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.roles.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.roles.export}
                title={"Roles de Carga de Datos"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default Roles;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Proyectos_Roles/Roles.js